import { Media } from 'domains/media';
import { MediaResponseDTO } from 'infrastructure/dtos/media';

export class MediaMapper {
  static fromDTO(mediaResponseDTO: MediaResponseDTO): Media {
    return new Media(
      mediaResponseDTO.media_type,
      mediaResponseDTO.media_url,
      mediaResponseDTO.id,
      mediaResponseDTO.children?.data.map(
        child => new Media(child.media_type, child.media_url, child.id, [])
      ) ?? []
    );
  }
}
